module.exports = __webpack_public_path__ + "static/media/jrOp.0487aff3.png";